import { types } from "mobx-state-tree";
import { ValidationMesssageModel } from "../ValidationMesssage";
import { ValidatorModel } from "../Validator";

const OptionModel = types
  .model({
    option: types.frozen(),
  })
  .actions((self) => {
    return {
      set(value: any) {
        self.option = value;
      },
    };
  });

export const RequiredOptionValidatorModel = types
  .compose(ValidatorModel, OptionModel)
  .actions((self) => {
    return {
      validate() {
        if (self.option?.isValid) return undefined;

        return ValidationMesssageModel.create({
          message: { mainKey: "general.validation.required" },
        });
      },
    };
  });
